module.exports = __webpack_public_path__ + "img/edit.a2c19487.png";